import { SendPolicyDocumentsByEmailClientRequest } from '../../../@types/SendPolicyDocumentsByEmail'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { usePolicyDocumentsSelectedStore } from '../../../Stores/usePolicyDocumentsSelectedStore'

export const useSendPolicyDocumentsByEmailPayload = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { createProposal } = useCreateProposalStore()
  const { policyDocuments } = usePolicyDocumentsSelectedStore()

  const payload: SendPolicyDocumentsByEmailClientRequest = {
    clientName: policyholderDetailsSelected?.name || '',
    fromEmail: '', //TODO: Review this data
    recipientEmail: policyholderAdditionalDetails?.emailContact?.email || '',
    documents: policyDocuments.map((item) => ({
      ...item,
      name: `${item?.name?.trim()}.pdf`,
    })),
    policyId: createProposal?.createProposalResponse?.proposalId,
  }
  return { payload }
}
